import { formatBytes } from '.';
import { SelectedFile } from '../types/file';

/**
 * 画像が選択されたときに走る共通処理
 */
export function validateImageFile(file: File, maxSizeBytes: number, setFile: (file: SelectedFile) => void): void {
  // 拡張子を抽出
  const extName = file.name.split('.').pop()?.split('?')[0];
  const extNameLowerCase = extName?.toLowerCase();
  const ext = {
    message: extNameLowerCase || '',
    valid:
      extNameLowerCase === 'jpg' ||
      extNameLowerCase === 'jpeg' ||
      extNameLowerCase === 'png' ||
      extNameLowerCase === 'gif',
  };

  // ファイルサイズを計測
  const length = {
    message: formatBytes(file.size),
    valid: file.size < maxSizeBytes,
  };

  setFile({
    ext,
    length,
    file,
    deleteFlag: false,
    toUpdate: true,
  });
}
